export default __webpack_public_path__ + "static/media/flag.44d5b4fe.svg";